import React, { memo, useEffect, useRef, useState } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useGetSlotSegmentsQuery } from '../../../redux/globalOverview';

import './SplitShiftDetailsOverlay.scss';

const SplitShiftDetailsOverlay = ({ slotId, managementCompanyId, triggerClassName, segmentsCount, children }) => {
	const overlayPanelRef = useRef(null);
	const hideTimeoutRef = useRef(null);
	const triggerRef = useRef(null);
	const [hasHovered, setHasHovered] = useState(false);

	const { data: segments = [], isFetching } = useGetSlotSegmentsQuery(
		{ slotId, managementCompanyId },
		{ skip: !hasHovered }
	);

	const placeholderRowCount = segmentsCount > 0 ? segmentsCount : 1;
	const placeholderRowKeys = Array.from({ length: placeholderRowCount }, (_, index) => `skeleton-${index}`);

	const cancelHide = () => {
		if (hideTimeoutRef.current) {
			clearTimeout(hideTimeoutRef.current);
			hideTimeoutRef.current = null;
		}
	};

	const scheduleHide = () => {
		cancelHide();
		hideTimeoutRef.current = setTimeout(() => {
			if (overlayPanelRef.current) {
				overlayPanelRef.current.hide();
			}
		}, 150);
	};

	const handleTriggerMouseEnter = (event) => {
		cancelHide();
		setHasHovered(true);
		triggerRef.current = event.currentTarget;
		if (overlayPanelRef.current) {
			overlayPanelRef.current.show(event, event.currentTarget);
		}
	};

	useEffect(
		() => () => {
			if (hideTimeoutRef.current) {
				clearTimeout(hideTimeoutRef.current);
			}
		},
		[]
	);

	return (
		<>
			<span className={triggerClassName} onMouseEnter={handleTriggerMouseEnter} onMouseLeave={scheduleHide}>
				{children}
			</span>
			<OverlayPanel ref={overlayPanelRef} className="split-shift-details-overlay">
				<div onMouseEnter={cancelHide} onMouseLeave={scheduleHide}>
					<div className="split-shift-details-overlay__title">Split shift details</div>
					<table className="split-shift-details-overlay__table">
						<thead>
							<tr>
								<th>Segment</th>
								<th>Time</th>
								<th>Unit</th>
							</tr>
						</thead>
						<tbody>
							{isFetching
								? placeholderRowKeys.map((rowKey) => (
										<tr key={rowKey}>
											<td className="split-shift-details-overlay__table__segment-number">
												<span className="split-shift-details-overlay__loading" />
											</td>
											<td>
												<span className="split-shift-details-overlay__loading" />
											</td>
											<td>
												<span className="split-shift-details-overlay__loading" />
											</td>
										</tr>
								  ))
								: segments.map((segment) => (
										<tr key={segment.segment_number}>
											<td className="split-shift-details-overlay__table__segment-number">{segment.segment_number}</td>
											<td>{segment.time_range}</td>
											<td>{segment.unit_name || '-'}</td>
										</tr>
								  ))}
						</tbody>
					</table>
				</div>
			</OverlayPanel>
		</>
	);
};

export default memo(SplitShiftDetailsOverlay);
